var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._g(_vm._b({attrs:{"variant":"link","aria-label":_vm.ariaLabel}},'b-btn',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners),[_c('i',{staticClass:"p-1",class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }